import { FlightSearchTypes } from '../constants';

const getFlightRouteLabel = ({ flightSegments, flightSearchType, segmentIndex }) => {
  if (!flightSegments || !flightSegments[segmentIndex]) return '';

  const segment = flightSegments[segmentIndex];
  const isMultiCity = flightSearchType === FlightSearchTypes.MULTI_CITY;

  let origin = segment.origin?.airportCode || segment.origin?.label || '';
  let destination = segment.destination?.airportCode || segment.destination?.label || '';

  // For round-trip return segment, reverse the outbound origin/destination
  if (!origin && !destination && !isMultiCity && segmentIndex > 0 && flightSegments[0]) {
    const outbound = flightSegments[0];
    origin = outbound.destination?.airportCode || outbound.destination?.label || '';
    destination = outbound.origin?.airportCode || outbound.origin?.label || '';
  }

  if (origin && destination) return `${origin} to ${destination}`;
  return '';
};

export default getFlightRouteLabel;
